import { forwardRef } from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

const colorMap = {
  white: "#ffffff",
  dark: "#344767",
  light: "#f8f9fa",
  primary: "#EC407A",
  secondary: "#747b8a",
  info: "#1A73E8",
  success: "#4CAF50",
  warning: "#fb8c00",
  error: "#F44335",
  transparent: "transparent",
};

const gradientMap = {
  primary: "linear-gradient(195deg, #EC407A, #D81B60)",
  secondary: "linear-gradient(195deg, #747b8a, #495361)",
  info: "linear-gradient(195deg, #49a3f1, #1A73E8)",
  success: "linear-gradient(195deg, #66BB6A, #43A047)",
  warning: "linear-gradient(195deg, #FFA726, #FB8C00)",
  error: "linear-gradient(195deg, #EF5350, #E53935)",
  dark: "linear-gradient(195deg, #42424a, #191919)",
  light: "linear-gradient(195deg, #EBEFF4, #CED4DA)",
};

const borderRadiusMap = {
  xs: "1.6px",
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  xxl: "24px",
  section: "160px",
};

const shadowMap = {
  xs: "0px 2px 9px -5px rgba(0, 0, 0, 0.15)",
  sm: "0px 5px 10px rgba(0, 0, 0, 0.12)",
  md: "0px 4px 6px -1px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.07)",
  lg: "0px 8px 26px -4px rgba(0, 0, 0, 0.15), 0px 8px 9px -5px rgba(0, 0, 0, 0.06)",
  xl: "0px 23px 45px -11px rgba(0, 0, 0, 0.25)",
  xxl: "0px 20px 27px rgba(0, 0, 0, 0.05)",
  inset: "inset 0px 1px 2px rgba(0, 0, 0, 0.075)",
};

const PointieBox = forwardRef(
  ({ variant, bgColor, color, opacity, borderRadius, shadow, ...rest }, ref) => {
    const sx = { ...rest.sx };

    // Background
    if (variant === "gradient" && bgColor) {
      sx.background = gradientMap[bgColor] || bgColor;
    } else if (bgColor) {
      sx.backgroundColor = colorMap[bgColor] || bgColor;
    }

    // Text color
    if (color) {
      sx.color = colorMap[color] || color;
    }

    // Opacity
    if (opacity !== undefined && opacity !== 1) {
      sx.opacity = opacity;
    }

    // Border radius
    if (borderRadius) {
      sx.borderRadius = borderRadiusMap[borderRadius] || borderRadius;
    }

    // Shadow
    if (shadow && shadow !== "none") {
      sx.boxShadow = shadowMap[shadow] || shadow;
    }

    return <Box ref={ref} {...rest} sx={sx} />;
  }
);

PointieBox.displayName = "PointieBox";
PointieBox.propTypes = {
  variant: PropTypes.string,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.number,
  borderRadius: PropTypes.string,
  shadow: PropTypes.string,
};
export default PointieBox;
